<template>
    <div>
        <!-- Consultar Pedido -->
        <div class="modal fade" id="consultarPedidoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl model-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Consultar Pedido</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <az-input
                                label="Pedido"
                                v-model="numero_pedido">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <div class="input-group-text" v-if="total_geral">
                                            {{ total_selecionados }}/{{ total_geral }}
                                        </div>

                                        <button 
                                            :disabled="!numero_pedido || $store.state.loading"
                                            class="btn btn-outline-primary" 
                                            type="button"
                                            @click="buscar_pedido()">
                                            <i class="fas fa-sync-alt fa-fw"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>

                        <div v-if="dados && dados.lista && dados.lista.length">

                            <div class="alert alert-info" v-if="dados.pedido">
                                <div v-if="dados.pedido.carteira">
                                    Carteira: {{ dados.pedido.carteira }}
                                </div>
                                <div v-if="dados.pedido.nomeProfissional">
                                    Solicitante: {{ dados.pedido.nomeProfissional}}
                                </div>
                            </div>

                            <div class="progress mb-2">
                                <div class="progress-bar bg-success" role="progressbar" :style="{ width: (total_selecionados / total_geral * 100) + '%' }"></div>
                            </div>
                        
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Código</th>
                                        <th>Descrição</th>
                                        <th>Procedimento</th>
                                        <th>Material</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(exame, iex) in dados.lista" :key="iex" :class="exame.procedimento ? 'table-success' : ''">
                                        <td>{{ iex + 1 }}</td>
                                        <td>{{ exame.codigo }}</td>
                                        <td>{{ exame.descricao }}</td>
                                        <td>
                                            <az-input
                                                v-if="( exame.procedimentos && exame.procedimentos.length )"
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecionar..."
                                                :optionsList="exame.procedimentos"
                                                v-model="exame.procedimento">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <div class="input-group-text">
                                                            {{ exame.procedimentos ? exame.procedimentos.length : 0 }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <az-input
                                                v-else-if="id_operadora && id_plano && id_unidade_operacao"
                                                placeholder="Procedimento"
                                                icon="fa fa-search"
                                                sizing="sm"
                                                type="autocomplete"
                                                optionsMode="aql"
                                                :optionsName="( ( $store.state.user.proc_oper ) ? 'procedimentos.combos.agenda.op.' 
                                                    + ( ( id_operadora == 1 ? 'p.' + id_plano : id_operadora ) ) : 'procedimentos.combos.agenda' )
                                                    + ( id_unidade_operacao ? '.uo' + id_unidade_operacao : '' )"
                                                :optionsParm="( $store.state.user.proc_oper ) 
                                                    ? { id_operadora: id_operadora, id_plano: id_plano, id_unidade_operacao: id_unidade_operacao } 
                                                    : { id_unidade_operacao: id_unidade_operacao }"
                                                :optionsSync="false"
                                                v-model="exame.procedimento"
                                                @input="selecao_procedimento(exame)"
                                                ref="info_procedimento"
                                                :procsigla="false">
                                            </az-input>
                                        </td>   
                                        <td>
                                            <template v-if="exame.procedimento && exame.procedimento.amostras && exame.procedimento.amostras.length">
                                                <az-input
                                                    sizing="sm"
                                                    type="select"
                                                    placeholder="Selecionar..."
                                                    :optionsList="exame.procedimento.amostras"
                                                    v-model="exame.amostra" />
                                            </template>

                                            <template v-else>
                                                <az-input
                                                    sizing="sm"
                                                    type="label"
                                                    value="Material..." />
                                            </template>

                                            <pre v-if="false">{{ exame.procedimento }}</pre>
                                        </td>
                                    </tr>   
                                </tbody>
                            </table>
                        </div>

                        <div v-else>
                            <az-empty-state msg="Procedimentos" icon="fa fa-list" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <az-submit @click="incluir_itens()" v-if="dados">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            dados: null, 
            numero_pedido: "", 
        };
    },

    components: { 
        AzInput, 
        AzSubmit,
        AzEmptyState, 
    },

    computed: { 
        total_selecionados: function() { 
            if ( !this.dados || !this.dados.lista ) 
                return 0;

            return this.dados.lista.filter(item => item.procedimento).length;
        },

        total_geral: function() { 
            if ( !this.dados || !this.dados.lista ) 
                return 0;

            return this.dados.lista.length;
        },
    },

    props: ['id_marcacao', 'id_plano', 'id_operadora', 'id_unidade_operacao'],

    methods: { 
        incluir_itens () { 
            if ( this.dados && this.dados.lista && this.dados.lista.length ) { 

                this.$parent.novoProcedimento = this.dados.lista.filter(item => item.procedimento)
                    .map(item => { 
                        let novo = item.procedimento; 
                        novo.amostras = item.procedimento.amostras || [];
                        novo.id_amostra_material = item.amostra ? item.amostra.id_amostra_material : null;
                        return novo;
                    });

                this.$parent.incluirProcedimento(); 

            }

            this.fechar_modal();
        },
        selecao_procedimento (exame) { 
            if ( exame && exame.procedimento && exame.procedimento.id_procedimento && !exame.procedimento.amostras ) { 

                exame.procedimento.amostras = []; 

                this.$util.loadItem(this, { 
                    service: 'procedimentos', 
                    func: 'show', 
                    parms: { id: exame.procedimento.id_procedimento, amostras: true },
                })
                .then(res => { 
                    exame.procedimento.amostras = _.orderBy(res.amostras, item => { 
                        let ordem = _.get(item, 'amostra_material.search'); 
                        return ordem;
                    }, 'asc');

                    if ( exame.procedimento.amostras && exame.procedimento.amostras.length == 1 ) { 
                        exame.amostra = _.first(exame.procedimento.amostras);
                    } else { 
                        exame.amostra = ""; 
                    }

                    this.$forceUpdate();
                });

            } else if ( exame && exame.procedimento && exame.procedimento.id_procedimento && exame.procedimento.amostras && exame.procedimento.amostras.length ) { 

                exame.procedimento.amostras = _.orderBy(exame.procedimento.amostras, item => { 
                    let ordem = _.get(item, 'amostra_material.search'); 
                    return ordem;
                }, 'asc');

                if ( exame.procedimento.amostras && exame.procedimento.amostras.length == 1 ) { 
                    exame.amostra = _.first(exame.procedimento.amostras);
                } else { 
                    exame.amostra = ""; 
                }
                
            }

        },

        abrir () { 
            this.numero_pedido = "";
            this.dados = null; 

            $('#consultarPedidoModal').modal('show');
        },

        fechar_modal() { 
            $('#consultarPedidoModal').modal('hide');
        },

        buscar_pedido () { 
            this.dados = null; 

            this.$util.load(this, { 
                service: 'atendimentos',
                func: 'buscar_pedido', 
                parms: { 
                    pedido: this.numero_pedido, 
                    id_marcacao: this.id_marcacao,
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    }
}
</script>